import {
    Component,
    Input,
} from '@angular/core';
import * as FILE_CONSTANT from 'src/app/components/casos/ver-tarea/constants/file.constant';
import { FilesService } from 'src/app/core/services/files.service';
import { ICaseFile } from 'src/app/modules/cases/interfaces/case-file.interface';

@Component({
    selector: 'file-show-view',
    templateUrl: './file-show-view.component.html',
    styleUrls: ['./file-show-view.component.scss'],
})
export class FileShowViewComponent {
    @Input() tab: ICaseFile = null;

    imageString: string = FILE_CONSTANT.IMAGE_STRING;
    audioString: string = FILE_CONSTANT.AUDIO_STRING;
    videoString: string = FILE_CONSTANT.VIDEO_STRING;
    textString: string = FILE_CONSTANT.TEXT_STRING;
    pdfString: string = FILE_CONSTANT.PDF_STRING;
    excelString: string = FILE_CONSTANT.EXCEL_STRING;
    csvString: string = FILE_CONSTANT.CSV_STRING;
    wordString: string = FILE_CONSTANT.WORD_STRING;

    fileType: string = null;

    constructor(private fileService: FilesService) {
    }
    /**
     * Determina si la extensión de un nombre de archivo corresponde a un formato de imagen común.
     * @param fileName El nombre completo del archivo (ej: 'mi_foto.jpg').
     * @returns 'true' si es una extensión de imagen, 'false' en caso contrario.
     */
    validate(fileName: string, type: string): boolean {
        this.tab.url = this.fileService.transformarUrl(this.tab.url);

        if (!fileName || typeof fileName !== 'string') {
            return false;
        }

        let extensions = null;
        switch (type) {
            case this.imageString:
                extensions = FILE_CONSTANT.IMAGE_EXTENSIONS;
                break;
            case this.audioString:
                extensions = FILE_CONSTANT.AUDIO_EXTENSIONS;
                break;
            case this.videoString:
                extensions = FILE_CONSTANT.VIDEO_EXTENSIONS;
                break;
            case this.textString:
                extensions = FILE_CONSTANT.TEXT_EXTENSIONS;
                break;
            case this.pdfString:
                extensions = FILE_CONSTANT.PDF_EXTENSIONS;
                break;
            case this.excelString:
                this.fileType = FILE_CONSTANT.EXCEL_STRING;
                extensions = FILE_CONSTANT.EXCEL_EXTENSIONS;
                break;
            case this.csvString:
                this.fileType = FILE_CONSTANT.CSV_STRING;
                extensions = FILE_CONSTANT.CSV_EXTENSIONS;
                break;
            case this.wordString:
                extensions = FILE_CONSTANT.WORD_EXTENSIONS;
                break;
            default:
                return false;
        }

        // 1. Obtiene la parte de la extensión
        const parts = fileName.toLowerCase().split('.');
        // Si no hay un punto o la última parte es solo el nombre del archivo (sin extensión)
        if (parts.length <= 1) {
            return false;
        }

        // La extensión es el último elemento del array 'parts'
        const extension = parts[parts.length - 1];

        // 2. Verifica si la extensión está en la lista
        return extensions.includes(extension);
    }

}
